import L from 'leaflet';

function normalizeMarkerColor(color: string): string {
  const s = (color || '').trim();
  if (!s) return '#808080';
  if (s.startsWith('#')) return s;
  if (/^[0-9A-Fa-f]{6}$/.test(s)) return `#${s}`;
  return s;
}

export function createBaseMarkerIcon(): L.DivIcon {
  const size = 38;
  const basePoiGray = '#756f6b';
  const innerIcon = Math.round(size * 0.48);
  const shadowLayers =
    '0 2px 6px rgba(0,0,0,0.35), 0 1px 2px rgba(0,0,0,0.22)';

  return L.divIcon({
    className: 'custom-route-marker custom-base-marker',
    html: `
          <div style="
            width: ${size}px;
            height: ${size}px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: ${shadowLayers};
            cursor: pointer;
            background: ${basePoiGray};
            color: #ffffff;
            box-sizing: border-box;
          ">
            <svg width="${innerIcon}" height="${innerIcon}" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style="flex-shrink: 0;">
              <path d="M12 2L2 10v12h7v-7h6v7h7V10L12 2z"/>
            </svg>
          </div>
        `,
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
  });
}

export function createRouteVisitPinIcon(order: number, color: string): L.DivIcon {
  const pinWidth = 50;
  const pinHeight = Math.round(pinWidth * (48 / 36));
  const cx = pinWidth / 2;
  const bgColor = normalizeMarkerColor(color);
  const orderDigits = order >= 100 ? 3 : order >= 10 ? 2 : 1;
  const numFont = orderDigits >= 3 ? 10 : orderDigits === 2 ? 11 : 13;
  const rCircle = 7.8;
  const gradientId = `route-pin-m-${Math.random().toString(36).slice(2, 11)}`;
  const strokeW = 1.9;

  return L.divIcon({
    className: 'custom-route-marker',
    html: `
        <div style="width:${pinWidth}px;height:${pinHeight}px;cursor:pointer;">
          <svg width="${pinWidth}" height="${pinHeight}" viewBox="0 0 36 48" preserveAspectRatio="xMidYMid meet" style="display:block;filter:drop-shadow(0 4px 10px rgba(0,0,0,0.35));">
            <defs>
              <linearGradient id="${gradientId}" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" style="stop-color:${bgColor};stop-opacity:1" />
                <stop offset="100%" style="stop-color:${bgColor};stop-opacity:0.88" />
              </linearGradient>
            </defs>
            <path d="M 18 3 Q 33 3 33 16 Q 33 29 18 45 Q 3 29 3 16 Q 3 3 18 3 Z"
              fill="url(#${gradientId})" stroke="white" stroke-width="${strokeW}"/>
            <circle cx="18" cy="14.5" r="${rCircle}" fill="white" stroke="rgba(0,0,0,0.18)" stroke-width="1.3"/>
            <text x="18" y="14.5" text-anchor="middle" dominant-baseline="central"
              fill="#111827" font-weight="800" font-size="${numFont}" font-family="system-ui,-apple-system,sans-serif">${order}</text>
          </svg>
        </div>
      `,
    iconSize: [pinWidth, pinHeight],
    iconAnchor: [cx, pinHeight],
    popupAnchor: [0, -pinHeight],
  });
}
